module.exports = __webpack_public_path__ + "img/biter-die-2.b1856bb1.png";